import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface GetOCTableViewColumnsRequestParams {
  GridName?: string;
}

export interface OCTableViewColumnOption {
  fieldReferenceName: string;
  fieldReferenceValue: string;
}

export const getOCTableViewColumnsAPI = (
  params: GetOCTableViewColumnsRequestParams = { GridName: 'OverChargeClaims' },
) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SECURITY}/GetGridColumnOptions`,
  });
};

export type GetOCTableViewColumnsResponse = OCTableViewColumnOption[];

export const fetchOCTableViewColumns = async (
  params?: GetOCTableViewColumnsRequestParams,
): Promise<GetOCTableViewColumnsResponse> => {
  const response: AxiosResponse<GetOCTableViewColumnsResponse> = await getOCTableViewColumnsAPI(params);
  return response.data;
};

export interface SaveOCTableViewColumnsData {
  columnOptions: Array<{
    fieldReferenceName: string;
    fieldReferenceValue: string;
  }>;
  gridName: string;
}

export const saveOCTableViewColumnsAPI = (data: SaveOCTableViewColumnsData) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SECURITY}/SaveGridColumnOption`,
  });
};

export type SaveOCTableViewColumnsResponse = unknown;

export const saveOCTableViewColumns = async (
  data: SaveOCTableViewColumnsData,
): Promise<SaveOCTableViewColumnsResponse> => {
  const response: AxiosResponse<SaveOCTableViewColumnsResponse> = await saveOCTableViewColumnsAPI(data);
  return response.data;
};
